import utils from "./utils.json"

const domain = utils.domain
const prodTag = utils.prodTag
const frontEndHost = `https://www.${domain}/`


export { domain }
export { prodTag }
export const webURL = frontEndHost



// WEBPACK FOOTER //
// ./src/webURL.js